import { MAX_FOLDER_NAME_LENGTH } from '@/constants/folderName';

export function truncateFolderNameLabel(name: string): string {
  if (name.length <= MAX_FOLDER_NAME_LENGTH) return name;
  return `${name.slice(0, MAX_FOLDER_NAME_LENGTH)}…`;
}

export function folderDeleteItemLabel(kind: 'material' | 'leistung' | 'vorlage'): string {
  if (kind === 'material') return 'Materialien';
  if (kind === 'vorlage') return 'Vorlagen';
  return 'Leistungen';
}
